import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { BrandEditTemplate } from 'components/Templates'

const BrandCreate: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const isEdit = !/\/admin\/brand\/create/.test(pathname)

  return (
    <Layout iconPath={'/icon/white/home.svg'} headline={'ブランド管理'} title={'ブランド管理'}>
      <BrandEditTemplate isEdit={isEdit} />
    </Layout>
  )
}

export default BrandCreate
